/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
 // Color palette. For more info, see /COLOR_PALETTE.md documentation.

var colors = [['#58BBDC', '#B6E6F7', '#81D0EA', '#36A6CB', '#168DB5'], // Primary color.
['#FFD060', '#FFEBB9', '#FFDC88', '#FFC63D', '#FFBB16'], // Secondary color (1).
['#FF7960', '#FFC4B9', '#FF9A88', '#FF5B3D', '#FF3A16']];
var colors0x = [[0x58BBDC, 0xB6E6F7, 0x81D0EA, 0x36A6CB, 0x168DB5], // Primary color.
[0xFFD060, 0xFFEBB9, 0xFFDC88, 0xFFC63D, 0xFFBB16], // Secondary color (1).
[0xFF7960, 0xFFC4B9, 0xFF9A88, 0xFF5B3D, 0xFF3A16]];
var debug = localStorage['debug'] === 'true' ? true : false;
module.exports = {
  debug: debug,
  scoreDefault: 0,
  scoreCollectStar: 10,
  // The game saves performance by not running code until it stops getting called for at least x milliseconds.
  debounceDelay: 250,
  // The game needs the player to notice something and will not run for x milliseconds.
  minimumDelay: 1500,
  colors: colors,
  colors0x: colors0x,
  headerFontFamily: '\'Gill Sans\', \'Gill Sans MT\', Calibri, \'Trebuchet MS\', sans-serif',
  gameWidth: 800,
  gameHeight: 600,
  gravity: 300,
  // World bounds can be greater than canvas gameWidth and gameHeight,
  // so the camera can move to new areas beyond the initial screen area.
  worldBoundsWidth: 800,
  worldBoundsHeight: 1200,
  skyKey: 'sky',
  skyAsset: 'assets/sky.svg',
  skyPositionX: 400,
  skyPositionY: 300,
  starsKey: 'star',
  starsAsset: 'assets/star.svg',
  starsRepeat: 11,
  starsPositionX: 14,
  starsPositionY: 60,
  starsPositionStepX: 70,
  starsMinBounceY: 0.2,
  starsMaxBounceY: 0.4,
  starsThresholdSpawnBomb: 0,
  stars: [// Ground.
  [154, 1157], [294, 1157], // Lowest block.
  [504, 1008], [574, 1008], [644, 1008], [14, 913], [84, 913], [364, 855], [434, 855], [714, 825], [784, 825], [224, 813], // Middle block.
  [504, 708], [574, 708], [644, 708], [14, 613], [84, 613], [364, 555], [434, 555], [714, 525], [784, 525], [224, 513], // Upper block.
  [504, 408], [574, 408], [644, 408], [14, 313], [84, 313], [364, 255], [434, 255], [714, 225], [784, 225], [224, 213]],
  platformKey: 'platform',
  platformAsset: 'assets/platform.svg',
  platformFrameWidth: 32,
  platformFrameHeight: 32,
  platformIsStatic: true,
  // platformsX, platformsY, platformsWidth, platformsHeight, and platformsFrame.
  platformsX: 0,
  platformsY: 1,
  platformsWidth: 2,
  platformsHeight: 3,
  platformsFrame: 4,
  platforms: [// Ground.
  [400, 1184, 32 * 25, 32, 1], // Lowest block.
  [462, 1035, 32, 32, 0], // 462 = 590 - (32 * 7 / 2) - (32 / 2)
  [590, 1035, 224, 32, 1], // 224 = 32 * 7
  [718, 1035, 32, 32, 2], // 718 = 590 + (32 * 7 / 2) + (32 / 2)
  [16, 940, 32, 32, 0], [48, 940, 32, 32, 1], [80, 940, 32, 32, 2], [336, 882, 32, 32, 0], [400, 882, 96, 32, 1], [464, 882, 32, 32, 2], [688, 852, 32, 32, 0], [736, 852, 64, 32, 1], [784, 852, 32, 32, 2], [188, 840, 32, 32, 0], [220, 840, 32, 32, 1], [252, 840, 32, 32, 2], // Middle block.
  [462, 735, 32, 32, 0], [590, 735, 224, 32, 1], [718, 735, 32, 32, 2], [16, 640, 32, 32, 0], [48, 640, 32, 32, 1], [80, 640, 32, 32, 2], [336, 582, 32, 32, 0], [400, 582, 96, 32, 1], [464, 582, 32, 32, 2], [688, 552, 32, 32, 0], [736, 552, 64, 32, 1], [784, 552, 32, 32, 2], [188, 540, 32, 32, 0], [220, 540, 32, 32, 1], [252, 540, 32, 32, 2], // Upper block.
  [462, 435, 32, 32, 0], [590, 435, 224, 32, 1], [718, 435, 32, 32, 2], [16, 340, 32, 32, 0], [48, 340, 32, 32, 1], [80, 340, 32, 32, 2], [336, 282, 32, 32, 0], [400, 282, 96, 32, 1], [464, 282, 32, 32, 2], [688, 252, 32, 32, 0], [736, 252, 64, 32, 1], [784, 252, 32, 32, 2], [188, 240, 32, 32, 0], [220, 240, 32, 32, 1], [252, 240, 32, 32, 2]],
  platformsFrameKeyLeft: 0,
  platformsFrameKeyMiddle: 1,
  platformsFrameKeyRight: 2,
  playerKey: 'hero',
  playerAsset: 'assets/hero.png',
  playerFrameWidth: 32,
  playerFrameHeight: 48,
  playerStartX: 120,
  playerStartY: 50,
  playerGravity: 30,
  playerBounce: 0.2,
  playerCollideWorldBounds: true,
  playerLeftVelocityX: -160,
  playerRightVelocityX: 160,
  playerTurnVelocityX: 0,
  playerUpVelocityY: -330,
  playerDeadTint: colors0x[1][0],
  playerMaxY: 1144,
  playerAnimations: {
    left: {
      key: 'left',
      frames: [0, 1, 2, 3],
      frameRate: 10,
      repeat: -1
    },
    turn: {
      key: 'turn',
      frame: 4,
      frameRate: 20
    },
    right: {
      key: 'right',
      frames: [0, 1, 2, 3],
      frameRate: 10,
      repeat: -1
    }
  },
  scoreTextPositionX: 8,
  scoreTextPositionY: 4,
  scoreTextDefault: 'Score: 0',
  scoreTextFontSize: '32px',
  scoreTextFill: colors[1][0],
  gameOverTextPositionX: 132,
  gameOverTextPositionY: 200,
  gameOverTextDefault: 'Game Over',
  gameOverTextFontSize: '120px',
  gameOverTextFill: colors[1][3],
  gameOverTextStroke: colors[2][0],
  gameOverTextStrokeThickness: 12,
  winTextPositionX: 155,
  winTextPositionY: 200,
  winTextDefault: 'You won!',
  winTextFontSize: '120px',
  winTextFill: colors[1][3],
  winTextStroke: colors[2][0],
  winTextStrokeThickness: 12,
  bombLeftEdge: 0,
  bombMiddleBorder: 400,
  bombRightEdge: 800,
  bombKey: 'bomb',
  bombAsset: 'assets/bomb.svg',
  bombStartPositionY: 16,
  bombBounce: 1,
  bombCollideWorldBounds: true,
  bombVelocityMinLower: -200,
  bombVelocityMaxLower: 200,
  bombVelocityMax: 20,
  bombAllowGravity: false,
  bombIsCircle: true,
  bombSpawnInterval: debug ? 150000 : 15000,
  audioCollectStarKey: 'collect-star',
  audioCollectStarAssets: ['assets/kenney-sounds/coin1.ogg', 'assets/kenney-sounds/coin1.mp3'],
  audioExplosionKey: 'explosion',
  audioExplosionAssets: ['assets/kenney-sounds/explosion1.ogg', 'assets/kenney-sounds/explosion1.mp3'],
  audioGameOverKey: 'gameover',
  audioGameOverAssets: ['assets/kenney-sounds/gameover3.ogg', 'assets/kenney-sounds/gameover3.mp3'],
  audioWinKey: 'win',
  audioWinAssets: ['assets/kenney-sounds/jingles_NES03.ogg', 'assets/kenney-sounds/jingles_NES03.mp3']
};

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_pwa__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_resize_game__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_debounce__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_boot_game__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_play_game__ = __webpack_require__(6);

/**
 * @author       Thomas Amar <hello@ebabel.eu>
 * @copyright    2018 eBabel Games
 * @license      {@link https://github.com/ebabel-games/2018-november/blob/master/LICENSE|GPL-3.0 License}
 */






 // The whole game is enclosed in an anonymous function that runs once all code is loaded.

window.addEventListener('load', function () {
  // Progressive Web App (PWA) configuration.
  Object(__WEBPACK_IMPORTED_MODULE_1__utils_pwa__["a" /* default */])(); // Phaser configuration.

  var config = {
    type: Phaser.AUTO,
    width: __WEBPACK_IMPORTED_MODULE_0__constants__["gameWidth"],
    height: __WEBPACK_IMPORTED_MODULE_0__constants__["gameHeight"],
    backgroundColor: __WEBPACK_IMPORTED_MODULE_0__constants__["colors0x"][0][4],
    physics: {
      default: 'arcade',
      arcade: {
        gravity: {
          y: __WEBPACK_IMPORTED_MODULE_0__constants__["gravity"]
        },
        debug: __WEBPACK_IMPORTED_MODULE_0__constants__["debug"]
      }
    },
    scene: [__WEBPACK_IMPORTED_MODULE_4__modules_boot_game__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__modules_play_game__["a" /* default */]]
  }; // Phaser main game object.

  var game = new Phaser.Game(config); // Get focus in case the game is in an iframe.

  window.focus(); // Handle resizing the whole game while preserving aspect ratio.

  Object(__WEBPACK_IMPORTED_MODULE_2__utils_resize_game__["a" /* default */])(game);
  window.addEventListener('resize', Object(__WEBPACK_IMPORTED_MODULE_3__utils_debounce__["a" /* default */])(function () {
    Object(__WEBPACK_IMPORTED_MODULE_2__utils_resize_game__["a" /* default */])(game);
  }, __WEBPACK_IMPORTED_MODULE_0__constants__["debounceDelay"]));
}); // Listen for the installation prompt.

var deferredPrompt;
window.addEventListener('beforeinstallprompt', function (e) {
  // Prevent Chrome 67 and earlier from automatically showing the prompt
  e.preventDefault(); // Stash the event so it can be triggered later.

  deferredPrompt = e; // Update UI notify the player they can add to home screen.

  document.getElementById('install-banner').style.display = 'block';
});
document.getElementById('install-button').addEventListener('click', function (e) {
  e.preventDefault();
  document.getElementById('install-banner').style.display = 'none'; // Show the prompt.

  deferredPrompt.prompt(); // Wait for the player to respond to the prompt.

  deferredPrompt.userChoice.then(function (choiceResult) {
    if (choiceResult.outcome === 'accepted') {
      deferredPrompt = null;
    }
  });
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Progressive Web App (PWA) setup.
// Note: also see file /service-worker.js, which should be a separate single file at the root of the website.
var pwa = function pwa() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('service-worker.js').then(function () {
      // Argument is registration.
      console.info('Game service worker is registered.');
      /* eslint no-console: 0 */
    }).catch(function (error) {
      console.error("Game service worker failed to register. ".concat(error.message));
      /* eslint no-console: 0 */
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (pwa);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * `resizeGame`
 * Handle resizing the whole game while preserving aspect ratio.
 * @param {Object} game Phaser game object. 
 */

var resizeGame = function resizeGame(game) {
  var canvas = document.querySelector('body > canvas');
  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;
  var windowRatio = windowWidth / windowHeight;
  var gameRatio = game.config.width / game.config.height;

  if (windowRatio < gameRatio) {
    canvas.style.width = "".concat(windowWidth, "px");
    canvas.style.height = "".concat(windowWidth / gameRatio, "px");
  } else {
    canvas.style.width = "".concat(windowHeight * gameRatio, "px");
    canvas.style.height = "".concat(windowHeight, "px");
  }
};

/* harmony default export */ __webpack_exports__["a"] = (resizeGame);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * `debounce`
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 * @param {Function} func The function that needs to be debounced.
 * @param {Number} wait Number of milliseconds to wait until the code is not called to finally execute it.
 * @param {Boolean} immediate Flag the function to debounce. true: trigger on the leading edge. false: trailing edge.
 * @author underscore.js
 * @description See David Walsh https://davidwalsh.name/javascript-debounce-function
 */

var _this = this,
    _arguments = arguments;

var debounce = function debounce(func, wait, immediate) {
  var timeout;

  var executedFunction = function executedFunction() {
    var context = _this;
    var args = _arguments;

    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };

  return executedFunction;
};

/* harmony default export */ __webpack_exports__["a"] = (debounce);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__constants__);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }


/**
 * `BootGame`
 * First Phaser scene, to preload all assets.
 */

var BootGame =
/*#__PURE__*/
function (_Phaser$Scene) {
  _inherits(BootGame, _Phaser$Scene);

  function BootGame() {
    _classCallCheck(this, BootGame);

    return _possibleConstructorReturn(this, _getPrototypeOf(BootGame).call(this, 'BootGame'));
  } // Phaser function to preload all assets.


  _createClass(BootGame, [{
    key: "preload",
    value: function preload() {
      // Graphics.
      this.load.image(__WEBPACK_IMPORTED_MODULE_0__constants__["skyKey"], __WEBPACK_IMPORTED_MODULE_0__constants__["skyAsset"]);
      this.load.spritesheet(__WEBPACK_IMPORTED_MODULE_0__constants__["platformKey"], __WEBPACK_IMPORTED_MODULE_0__constants__["platformAsset"], {
        frameWidth: __WEBPACK_IMPORTED_MODULE_0__constants__["platformFrameWidth"],
        frameHeight: __WEBPACK_IMPORTED_MODULE_0__constants__["platformFrameHeight"]
      });
      this.load.image(__WEBPACK_IMPORTED_MODULE_0__constants__["starsKey"], __WEBPACK_IMPORTED_MODULE_0__constants__["starsAsset"]);
      this.load.image(__WEBPACK_IMPORTED_MODULE_0__constants__["bombKey"], __WEBPACK_IMPORTED_MODULE_0__constants__["bombAsset"]);
      this.load.spritesheet(__WEBPACK_IMPORTED_MODULE_0__constants__["playerKey"], __WEBPACK_IMPORTED_MODULE_0__constants__["playerAsset"], {
        frameWidth: __WEBPACK_IMPORTED_MODULE_0__constants__["playerFrameWidth"],
        frameHeight: __WEBPACK_IMPORTED_MODULE_0__constants__["playerFrameHeight"]
      }); // Audio.

      this.load.audio(__WEBPACK_IMPORTED_MODULE_0__constants__["audioCollectStarKey"], __WEBPACK_IMPORTED_MODULE_0__constants__["audioCollectStarAssets"]);
      this.load.audio(__WEBPACK_IMPORTED_MODULE_0__constants__["audioExplosionKey"], __WEBPACK_IMPORTED_MODULE_0__constants__["audioExplosionAssets"]);
      this.load.audio(__WEBPACK_IMPORTED_MODULE_0__constants__["audioGameOverKey"], __WEBPACK_IMPORTED_MODULE_0__constants__["audioGameOverAssets"]);
      this.load.audio(__WEBPACK_IMPORTED_MODULE_0__constants__["audioWinKey"], __WEBPACK_IMPORTED_MODULE_0__constants__["audioWinAssets"]);
    } // Phaser function, here used to activate the play button once the preload has completed its work.

  }, {
    key: "create",
    value: function create() {
      var _this = this;

      document.getElementById('play-button').addEventListener('click', function (e) {
        e.preventDefault(); // Hide the loading screen when the player clicks on the enabled Play button.

        document.getElementById('loading').style.display = 'none'; // Hide the install banner.

        document.getElementById('install-banner').style.display = 'none'; // Display the canvas.

        document.querySelector('body > canvas').style.display = 'block';

        _this.scene.start('PlayGame');
      }); // Game has finished loading all assets, so it's possible to start playing.

      document.getElementById('play-button').disabled = false;
      document.getElementById('loading-animation').style.display = 'none';
    }
  }]);

  return BootGame;
}(Phaser.Scene);

/* harmony default export */ __webpack_exports__["a"] = (BootGame);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__constants__);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }


/**
 * `PlayGame`
 * Main Phaser scene to play the game.
 */

var PlayGame =
/*#__PURE__*/
function (_Phaser$Scene) {
  _inherits(PlayGame, _Phaser$Scene);

  function PlayGame() {
    var _this;

    _classCallCheck(this, PlayGame);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PlayGame).call(this, 'PlayGame'));
    _this.EG = {
      platforms: null,
      player: null,
      cursors: null,
      stars: null,
      score: __WEBPACK_IMPORTED_MODULE_0__constants__["scoreDefault"],
      scoreText: null,
      bombs: null,
      gameOver: false,
      gameOverText: null,
      win: false,
      winText: null,
      firstPlay: true,
      audioCollectStar: null,
      audioExplosion: null,
      audioGameOver: null,
      audioWin: null,
      bombSpawnIntervalId: null
    };
    return _this;
  }

  _createClass(PlayGame, [{
    key: "create",
    value: function create() {
      var _this2 = this;

      // Static element: the Sky.
      this.add.image(__WEBPACK_IMPORTED_MODULE_0__constants__["skyPositionX"], __WEBPACK_IMPORTED_MODULE_0__constants__["skyPositionY"], __WEBPACK_IMPORTED_MODULE_0__constants__["skyKey"]).setScrollFactor(0); // Stars to collect.

      this.EG.stars = this.physics.add.staticGroup();
      __WEBPACK_IMPORTED_MODULE_0__constants__["stars"].map(function (data) {
        var star = _this2.EG.stars.create(data[0], data[1], __WEBPACK_IMPORTED_MODULE_0__constants__["starsKey"]);

        if (__WEBPACK_IMPORTED_MODULE_0__constants__["debug"]) {
          star.setInteractive();

          _this2.input.setDraggable(star);
        }
      }); // Group of static platforms.

      this.EG.platforms = this.physics.add.staticGroup();
      __WEBPACK_IMPORTED_MODULE_0__constants__["platforms"].map(function (data) {
        var platform = _this2.add.tileSprite(data[__WEBPACK_IMPORTED_MODULE_0__constants__["platformsX"]], data[__WEBPACK_IMPORTED_MODULE_0__constants__["platformsY"]], data[__WEBPACK_IMPORTED_MODULE_0__constants__["platformsWidth"]], data[__WEBPACK_IMPORTED_MODULE_0__constants__["platformsHeight"]], __WEBPACK_IMPORTED_MODULE_0__constants__["platformKey"], data[__WEBPACK_IMPORTED_MODULE_0__constants__["platformsFrame"]]);

        _this2.EG.platforms.add(platform);

        if (__WEBPACK_IMPORTED_MODULE_0__constants__["debug"]) {
          platform.setInteractive();

          _this2.input.setDraggable(platform);
        }
      });
      this.physics.add.collider(this.EG.stars, this.EG.platforms);

      if (__WEBPACK_IMPORTED_MODULE_0__constants__["debug"]) {
        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
          gameObject.x = dragX;
          gameObject.y = dragY;
          console.log(dragX, dragY);
        });
      } // Setup main player sprite.


      var playerX = this.EG.firstPlay ? __WEBPACK_IMPORTED_MODULE_0__constants__["playerStartX"] : this.EG.player.x; // Default x position of player or previous game x position.

      var playerY = this.EG.firstPlay ? __WEBPACK_IMPORTED_MODULE_0__constants__["playerStartY"] : this.EG.player.y; // Same for y.

      this.EG.player = this.physics.add.sprite(playerX, playerY, __WEBPACK_IMPORTED_MODULE_0__constants__["playerKey"]);
      this.EG.player.body.setGravityY(__WEBPACK_IMPORTED_MODULE_0__constants__["playerGravity"]);
      this.EG.player.setBounce(__WEBPACK_IMPORTED_MODULE_0__constants__["playerBounce"]);
      this.EG.player.setCollideWorldBounds(__WEBPACK_IMPORTED_MODULE_0__constants__["playerCollideWorldBounds"]);
      this.physics.add.collider(this.EG.player, this.EG.platforms); // Check if player overlaps a star.

      this.physics.add.overlap(this.EG.player, this.EG.stars, this.collectStar, null, this); // Bombs that can kill the player.

      this.EG.bombs = this.physics.add.group();
      this.physics.add.collider(this.EG.bombs, this.EG.platforms);
      this.physics.add.collider(this.EG.bombs, this.EG.bombs);
      this.physics.add.collider(this.EG.player, this.EG.bombs, this.hitBomb, null, this); // Setup animations of the player sprite.

      if (this.EG.firstPlay) {
        this.anims.create({
          key: __WEBPACK_IMPORTED_MODULE_0__constants__["playerAnimations"].left.key,
          frames: this.anims.generateFrameNames(__WEBPACK_IMPORTED_MODULE_0__constants__["playerKey"], {
            frames: __WEBPACK_IMPORTED_MODULE_0__constants__["playerAnimations"].left.frames
          }),
          frameRate: __WEBPACK_IMPORTED_MODULE_0__constants__["playerAnimations"].left.frameRate,
          repeat: __WEBPACK_IMPORTED_MODULE_0__constants__["playerAnimations"].left.repeat
        });
        this.anims.create({
          key: __WEBPACK_IMPORTED_MODULE_0__constants__["playerAnimations"].turn.key,
          frames: [{
            key: __WEBPACK_IMPORTED_MODULE_0__constants__["playerKey"],
            frame: __WEBPACK_IMPORTED_MODULE_0__constants__["playerAnimations"].turn.frame
          }],
          frameRate: __WEBPACK_IMPORTED_MODULE_0__constants__["playerAnimations"].turn.frameRate
        });
        this.anims.create({
          key: __WEBPACK_IMPORTED_MODULE_0__constants__["playerAnimations"].right.key,
          frames: this.anims.generateFrameNames(__WEBPACK_IMPORTED_MODULE_0__constants__["playerKey"], {
            frames: __WEBPACK_IMPORTED_MODULE_0__constants__["playerAnimations"].right.frames
          }),
          frameRate: __WEBPACK_IMPORTED_MODULE_0__constants__["playerAnimations"].right.frameRate,
          repeat: __WEBPACK_IMPORTED_MODULE_0__constants__["playerAnimations"].right.repeat
        });
      } // Setup the score display.


      this.EG.scoreText = this.add.text(__WEBPACK_IMPORTED_MODULE_0__constants__["scoreTextPositionX"], __WEBPACK_IMPORTED_MODULE_0__constants__["scoreTextPositionY"], __WEBPACK_IMPORTED_MODULE_0__constants__["scoreTextDefault"], {
        fontFamily: __WEBPACK_IMPORTED_MODULE_0__constants__["headerFontFamily"],
        fontSize: __WEBPACK_IMPORTED_MODULE_0__constants__["scoreTextFontSize"],
        fill: __WEBPACK_IMPORTED_MODULE_0__constants__["scoreTextFill"]
      });
      this.EG.scoreText.setScrollFactor(0); // Game Over text to display when player loses.

      this.EG.gameOverText = this.add.text(__WEBPACK_IMPORTED_MODULE_0__constants__["gameOverTextPositionX"], __WEBPACK_IMPORTED_MODULE_0__constants__["gameOverTextPositionY"], __WEBPACK_IMPORTED_MODULE_0__constants__["gameOverTextDefault"], {
        fontFamily: __WEBPACK_IMPORTED_MODULE_0__constants__["headerFontFamily"],
        fontSize: __WEBPACK_IMPORTED_MODULE_0__constants__["gameOverTextFontSize"],
        fill: __WEBPACK_IMPORTED_MODULE_0__constants__["gameOverTextFill"],
        stroke: __WEBPACK_IMPORTED_MODULE_0__constants__["gameOverTextStroke"],
        strokeThickness: __WEBPACK_IMPORTED_MODULE_0__constants__["gameOverTextStrokeThickness"]
      });
      this.EG.gameOverText.setScrollFactor(0);
      this.EG.gameOverText.visible = false; // Level won text to display when player wins.

      this.EG.winText = this.add.text(__WEBPACK_IMPORTED_MODULE_0__constants__["winTextPositionX"], __WEBPACK_IMPORTED_MODULE_0__constants__["winTextPositionY"], __WEBPACK_IMPORTED_MODULE_0__constants__["winTextDefault"], {
        fontFamily: __WEBPACK_IMPORTED_MODULE_0__constants__["headerFontFamily"],
        fontSize: __WEBPACK_IMPORTED_MODULE_0__constants__["winTextFontSize"],
        fill: __WEBPACK_IMPORTED_MODULE_0__constants__["winTextFill"],
        stroke: __WEBPACK_IMPORTED_MODULE_0__constants__["winTextStroke"],
        strokeThickness: __WEBPACK_IMPORTED_MODULE_0__constants__["winTextStrokeThickness"]
      });
      this.EG.winText.setScrollFactor(0);
      this.EG.winText.visible = false; // Audio collect star sound when player collects a star.

      this.EG.audioCollectStar = this.sound.add(__WEBPACK_IMPORTED_MODULE_0__constants__["audioCollectStarKey"]); // Audio explosion sound when player hits a bomb.

      this.EG.audioExplosion = this.sound.add(__WEBPACK_IMPORTED_MODULE_0__constants__["audioExplosionKey"]); // Audio when player loses the game.

      this.EG.audioGameOver = this.sound.add(__WEBPACK_IMPORTED_MODULE_0__constants__["audioGameOverKey"]); // Audio when player wins the game.

      this.EG.audioWin = this.sound.add(__WEBPACK_IMPORTED_MODULE_0__constants__["audioWinKey"]); // Setup keyboard handling.

      this.EG.cursors = this.input.keyboard.createCursorKeys(); // Mouse/touch handling.

      this.input.on('pointerdown', function (pointer) {
        _this2.EG.cursors.right.isDown = _this2.EG.player.x < pointer.x;
        _this2.EG.cursors.left.isDown = _this2.EG.player.x > pointer.x;
        _this2.EG.cursors.up.isDown = _this2.EG.player.y - __WEBPACK_IMPORTED_MODULE_0__constants__["playerFrameHeight"] > pointer.y;
      });
      this.input.on('pointerup', function (pointer) {
        _this2.EG.cursors.right.isDown = false;
        _this2.EG.cursors.left.isDown = false;
        _this2.EG.cursors.up.isDown = false; // In debug mode, output the coordinates of the pointer in the console.

        if (__WEBPACK_IMPORTED_MODULE_0__constants__["debug"]) console.log("x: ".concat(pointer.x, ", y: ").concat(pointer.y));
        /* eslint no-console: 0 */
      }); // Set the world bounds.

      this.physics.world.bounds.width = __WEBPACK_IMPORTED_MODULE_0__constants__["worldBoundsWidth"];
      this.physics.world.bounds.height = __WEBPACK_IMPORTED_MODULE_0__constants__["worldBoundsHeight"]; // Set the camera to follow the player.

      this.cameras.main.setBounds(0, 0, __WEBPACK_IMPORTED_MODULE_0__constants__["worldBoundsWidth"], __WEBPACK_IMPORTED_MODULE_0__constants__["worldBoundsHeight"]);
      this.cameras.main.startFollow(this.EG.player); // At regular intervals, spawn a bomb.

      this.EG.bombSpawnIntervalId = setInterval(function () {
        _this2.spawnBomb();
      }, __WEBPACK_IMPORTED_MODULE_0__constants__["bombSpawnInterval"]); // Initially, spawn 1 bomb.

      this.spawnBomb();
    }
  }, {
    key: "spawnBomb",
    value: function spawnBomb() {
      var x = this.EG.player.x < __WEBPACK_IMPORTED_MODULE_0__constants__["bombMiddleBorder"] ? Phaser.Math.Between(__WEBPACK_IMPORTED_MODULE_0__constants__["bombMiddleBorder"], __WEBPACK_IMPORTED_MODULE_0__constants__["bombRightEdge"]) : Phaser.Math.Between(__WEBPACK_IMPORTED_MODULE_0__constants__["bombLeftEdge"], __WEBPACK_IMPORTED_MODULE_0__constants__["bombMiddleBorder"]);
      var bomb = this.EG.bombs.create(x, __WEBPACK_IMPORTED_MODULE_0__constants__["bombStartPositionY"], __WEBPACK_IMPORTED_MODULE_0__constants__["bombKey"]);
      bomb.setBounce(__WEBPACK_IMPORTED_MODULE_0__constants__["bombBounce"]);
      bomb.setCollideWorldBounds(__WEBPACK_IMPORTED_MODULE_0__constants__["bombCollideWorldBounds"]);
      bomb.setVelocity(Phaser.Math.Between(__WEBPACK_IMPORTED_MODULE_0__constants__["bombVelocityMinLower"], __WEBPACK_IMPORTED_MODULE_0__constants__["bombVelocityMaxLower"]), __WEBPACK_IMPORTED_MODULE_0__constants__["bombVelocityMax"]);
      bomb.allowGravity = __WEBPACK_IMPORTED_MODULE_0__constants__["bombAllowGravity"];
    } // When the player has lost and the game is paused,
    // prevent the keyboard from trying to move,
    // which can lock the player in a given direction.

  }, {
    key: "resetKeyboard",
    value: function resetKeyboard() {
      this.EG.cursors.left.enabled = false;
      this.EG.cursors.right.enabled = false;
      this.EG.cursors.up.enabled = false;
      this.EG.cursors.space.enabled = false;
      this.EG.cursors.down.enabled = false;
      this.EG.cursors.left.reset();
      this.EG.cursors.right.reset();
      this.EG.cursors.up.reset();
      this.EG.cursors.space.reset();
      this.EG.cursors.down.reset();
    } // The player has lost, reset variables.

  }, {
    key: "resetGame",
    value: function resetGame() {
      this.EG.score = __WEBPACK_IMPORTED_MODULE_0__constants__["scoreDefault"];
      this.EG.gameOver = false;
      this.EG.win = false;
      this.EG.firstPlay = false; // Make sure the player has not been pushed by a bomb below the ground.

      if (this.EG.player.y > __WEBPACK_IMPORTED_MODULE_0__constants__["playerMaxY"]) this.EG.player.y = __WEBPACK_IMPORTED_MODULE_0__constants__["playerMaxY"];
    } // Game loop function that gets called continuously unless a game over.

  }, {
    key: "update",
    value: function update() {
      var _this3 = this;

      if (this.EG.gameOver) {
        // Player has lost a game, suspend it and reset.
        this.EG.audioGameOver.play();
        this.EG.gameOverText.visible = true;
      }

      if (this.EG.win) {
        // Player has won and will move on to the next level.
        this.EG.audioWin.play();
        this.EG.winText.visible = true;
      }

      if (this.EG.gameOver || this.EG.win) {
        clearInterval(this.EG.bombSpawnIntervalId);
        this.scene.pause();
        setTimeout(function () {
          _this3.resetGame();

          _this3.resetKeyboard();

          _this3.scene.restart();
        }, __WEBPACK_IMPORTED_MODULE_0__constants__["minimumDelay"]);
        return;
      }

      if (this.EG.cursors.left.isDown) {
        this.EG.player.flipX = false;
        this.EG.player.setVelocityX(__WEBPACK_IMPORTED_MODULE_0__constants__["playerLeftVelocityX"]);
        this.EG.player.anims.play(__WEBPACK_IMPORTED_MODULE_0__constants__["playerAnimations"].left.key, true);
      } else if (this.EG.cursors.right.isDown) {
        this.EG.player.flipX = true;
        this.EG.player.setVelocityX(__WEBPACK_IMPORTED_MODULE_0__constants__["playerRightVelocityX"]);
        this.EG.player.anims.play(__WEBPACK_IMPORTED_MODULE_0__constants__["playerAnimations"].right.key, true);
      } else {
        this.EG.player.setVelocityX(__WEBPACK_IMPORTED_MODULE_0__constants__["playerTurnVelocityX"]);
        this.EG.player.anims.play(__WEBPACK_IMPORTED_MODULE_0__constants__["playerAnimations"].turn.key);
      }

      if ((this.EG.cursors.up.isDown || this.EG.cursors.space.isDown) && this.EG.player.body.touching.down) {
        // Prevent the player from jumping in mid-air. To jump player needs to rest on a hard surface.
        this.EG.player.setVelocityY(__WEBPACK_IMPORTED_MODULE_0__constants__["playerUpVelocityY"]);
      } // Spinning bombs.


      this.EG.bombs.children.entries.map(function (bomb) {
        return bomb.rotation += 0.1;
      });
    } // Player collects a star that it overlaps.

  }, {
    key: "collectStar",
    value: function collectStar(player, star) {
      this.EG.audioCollectStar.play();
      star.disableBody(true, true);
      this.EG.score += __WEBPACK_IMPORTED_MODULE_0__constants__["scoreCollectStar"];
      this.EG.scoreText.setText("Score: ".concat(this.EG.score)); // When all stars have been collected, player has won and can move to the next level.

      if (this.EG.stars.countActive(true) === __WEBPACK_IMPORTED_MODULE_0__constants__["starsThresholdSpawnBomb"]) {
        this.physics.pause();
        this.EG.win = true;
      }
    } // Player has hit a bomb.
    // Note: second parameter is 'bomb' but I don't need it.

  }, {
    key: "hitBomb",
    value: function hitBomb(player) {
      this.EG.audioExplosion.play();
      this.physics.pause();
      player.setTint(__WEBPACK_IMPORTED_MODULE_0__constants__["playerDeadTint"]);
      player.anims.play(__WEBPACK_IMPORTED_MODULE_0__constants__["playerAnimations"].turn.key);
      this.EG.gameOver = true;
    }
  }]);

  return PlayGame;
}(Phaser.Scene);

/* harmony default export */ __webpack_exports__["a"] = (PlayGame);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// game.min.js